import {Path, Svg} from 'react-native-svg';

const ItemFlagIcon = () => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <Path
      d="M3.5 8.68877C3.5 8.68877 4.1875 8.13579 6.25 8.13579C8.3125 8.13579 9.6875 9.24175 11.75 9.24175C13.8125 9.24175 14.5 8.68877 14.5 8.68877V2.05298C14.5 2.05298 13.8125 2.60596 11.75 2.60596C9.6875 2.60596 8.3125 1.5 6.25 1.5C4.1875 1.5 3.5 2.05298 3.5 2.05298V8.68877Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path d="M3.5 16.5001L3.5 8.7583" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default ItemFlagIcon;
